export const roundNumb = (num: number, count = 0) => {
  return +parseFloat(num.toFixed(count)) || 0;
};

export const dotToComma = (num: number | string) => num.toString().replace('.', ',');
